<template>
  <Head title="Walls" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="main walls">

        <div class="c-header">
          <Link :href="`/gyms/${gym.slug}`" class="c-header__back">
            <img src="/images/icons/icon-chevron-left.svg" alt="back">
          </Link>
          <h2 class="c-header--h2">{{ gym.title }}｜ウォール一覧</h2>
        </div>

        <div class="mt-24">

          <draggable v-model="walls" group="wall" item-key="id" animation="200" @change="update">
            <template #item="{element}">
              <div class="c-list_block">
                <div class="c-list_block_title">
                  {{ element.name }}
                </div>
                <div class="c-list_block_buttons">
                  <Link :href="`/walls/${element.id}/edit`" class="c-list_block_operation_link c-button small ml-4">編集</Link>
                  <Link @click="destroy(element.id)" class="c-list_block_operation_link c-button small red ml-4">削除</Link >
                  <div class="c-list_block_operation_drag handle" handle=".handle"><img src="/images/icons/icon-arrow-up-down.png" alt="drag"></div>
                </div>
              </div>
            </template>
          </draggable>

          <div class="admin-area" v-if="auth.user && user.can.isAdmin">
            <h3 class="admin-area_heading c-heading-h4">管理者エリア</h3>
            <div class="c-button-wrap">
              <Link :href="`/walls/create/${gym.id}`" class="c-button">ウォールを追加</Link>
            </div>
          </div>

        </div>

      </div>
      <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
import axios from 'axios';
import draggable from "vuedraggable";
import Side from '@/Shared/Side';

export default {
  components: {
    BreezeAuthenticatedLayout,
    Head,
    Link,
    draggable,
    Side,
  },
  props: {
    walls: Array,
    user: Object,
    gym: Object,
    auth: Object
  },
  methods: {
    update() {
      this.walls.map((wall, index) => {
        wall.order = index + 1;
      })

      axios.put('/walls/updateAll', {
        walls: this.walls,
        gym_id: this.gym.id
      }).then((response) => {
        // flash success message etc
      })
    },
    destroy(id) {
        if (confirm('本当に削除しますか？')) {
            this.$inertia.delete(route("walls.destroy", id));
        }
    },
  },
}
</script>
